/**
 * Maps a course's standard code to a real certification mark, where the project
 * holds one.
 *
 * Most ISO codes resolve by shape alone — "ISO 9001" -> "iso-9001" — so the
 * table below only carries the ones whose registry key differs from the code.
 * Anything with no mark returns null and the card keeps its icon; nothing is
 * substituted with a look-alike badge.
 *
 * NOTE this is deliberately a small set. 13 of the 103 course codes have a mark
 * in src/data/certificationLogos.js; the reference build at
 * mbasol-test-eosin.vercel.app carries the same handful of badges and no
 * per-course artwork either, so there is nothing further to import.
 */
import { CERTIFICATION_LOGOS } from "../../data/certificationLogos";

const ALIASES = {
  haccp: "haccp",
  halal: "halal",
  "fssc 22000": "fssc-22000",
  brcgs: "brcgs",
  gmp: "gmp",
  gots: "gots",
  grs: "grs",
  rcs: "rcs-ocs",
  ocs: "rcs-ocs",
  wrap: "wrap",
  sedex: "sedex-smeta",
  smeta: "sedex-smeta",
  fsc: "fsc-coc",
  pefc: "pefc",
  ecovadis: "ecovadis",
  sa8000: "sa8000",
  gri: "gri",
};

/** @returns {string|null} registry key for this course code, or null */
export const courseLogoKey = (iso) => {
  if (!iso) return null;
  const name = iso.trim().toLowerCase();
  if (ALIASES[name]) return ALIASES[name];
  const key = name.replace(/\s+/g, "-");
  return CERTIFICATION_LOGOS[key] ? key : null;
};

export default courseLogoKey;
